"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._Initiator = {
    type: "structure",
    required: [],
    members: {
        ID: {
            shape: {
                type: "string"
            }
        },
        DisplayName: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_Initiator.js.map